import { commonGuard, adminGuard } from "../func"

const departmentRouter = {
  path: "department",
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: "",
      name: "department",
      redirect: { name: "department-list" },
      beforeEnter: adminGuard,
      component: () => import("@/components/department/index.vue"),
      children: [
        {
          path: "",
          name: "department-list",
          beforeEnter: adminGuard,
          component: () => import("@/components/department/list.vue"),
        },
        {
          path: ":groupFk",
          name: "department-sub",
          beforeEnter: adminGuard,
          component: () => import("@/components/department/list.vue"),
          props: true,
        },
      ],
    },
  ],
}

export default departmentRouter
